import { Breadcrumb } from 'antd'

import _map from 'lodash/map'

import Styled from './styled'

export default function MyBreadcrumb({ items = [], ...props }) {
  return (
    <Styled>
      <Breadcrumb separator=">" {...props}>
        {_map(items, (item, index) => {
          const lebel = item?.label
          const link = item?.link
          return (
            <Breadcrumb.Item key={index}>
              {link ? <a href={link}>{lebel}</a> : lebel}
            </Breadcrumb.Item>
          )
        })}
      </Breadcrumb>
    </Styled>
  )
}
